import { showNotification } from '../utils/showNotification'

export function useNotifications() {
  return { showNotification }
}
